export default __webpack_public_path__ + "static/media/Party Popper 1.bd5ceafc.png";